import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getISCO4OccupationAis = async (ISCO4Codes: string[]) => {
    const { path, method } = endpoints.occupationAndSector.getISCO4OccupationAis;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { ISCO4Codes },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
